import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export enum VerificationView {
  Confirm = "confirm",
  Update = "update",
  Verify = "verify",
  Next = "next",
}

interface VerificationState {
  currentView: VerificationView;
}

const initialState: VerificationState = {
  currentView: VerificationView.Confirm,
};

const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    setCurrentView(state, action: PayloadAction<VerificationView>) {
      state.currentView = action.payload;
    },
  },
});

export const { setCurrentView } = verificationSlice.actions;
export default verificationSlice.reducer;
